import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function EmailCapture() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email, source: "homepage" });
      toast.success(data.already ? "You're already on the list — welcome back!" : "You're in. Watch your inbox for member deals.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="email-capture" className="relative overflow-hidden bg-brand-deep-red text-white grain">
      <div className="container-rv relative z-10 py-24 text-center lg:py-28">
        <Reveal>
          <p className="overline text-white/70">Members save more</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-serif text-4xl font-bold leading-tight sm:text-5xl">
            Join the Reverence list for member-only discounts
          </h2>
          <form onSubmit={submit} className="mx-auto mt-10 flex max-w-md overflow-hidden rounded-full border border-white/40 bg-white/10 p-1.5 backdrop-blur-sm focus-within:border-white">
            <input
              type="email"
              required
              data-testid="email-capture-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full bg-transparent px-5 text-sm text-white placeholder:text-white/60 focus:outline-none"
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="email-capture-button"
              className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-brand-red transition-transform duration-300 hover:-translate-y-0.5 disabled:opacity-60"
            >
              {busy ? "Joining…" : <>Join <ArrowRight className="h-4 w-4" /></>}
            </button>
          </form>
          <p className="mt-4 text-xs text-white/60">No spam. Just seasonal specials & early access.</p>
        </Reveal>
      </div>
    </section>
  );
}
